export enum FlagEnum {
  Yes = 'Yes',
  No = 'No',
  Y = 'Y',
  N = 'N',
}

export enum PageLayoutMode {
  NONE = 'N',
  ADMIN = 'A',
  EDIT = 'E', //can edit/view fields
  SEARCH = 'S', //a empty view for triggering searches
  VIEW = 'V' //view only data mode
}

export enum DataSourceFlag {
  Reference = 'R', //search only
  Transactional = 'T', //manually added entries only
  NoLimitation = 'N', //both,
  None = 'X'
}

export enum DropDownListShowType {
  /// <summary>
  /// show value
  /// </summary>
  ShowValue = 0,

  /// <summary>
  /// show description

  /// </summary>
  ShowDescription = 1,

  /// <summary>
  /// show value and description
  /// </summary>
  ShowBoth = 2
}
